{
  "completed": "Užbaigta: ",
  "current": "Dabartinis: ",
  "notCompleted": "Ne pabaigtas: ",
  "steplist": "Žingsnių sąrašas"
}
